import React, { useState, useContext, useRef } from 'react'
import { createPortal } from 'react-dom';
import { LassieContext } from "../../context/LassieProvider";
import { organizationUserAPI } from '../../api';
import WplSwitch from '../wpl-switch/wplSwitch';
import OptionsMenu from '../options-menu/OptionsMenu';
import addIcon from '../../assets/img/add-icon.png'
import editWhiteIcon from '../../assets/img/edit-white-icon.png';
import editIcon from '../../assets/img/edit-blue-icon.png';
import adminIcon from '../../assets/img/admin-icon.png';
import optionIcon from "../../assets/img/option-icon.png";
import copySettingsIconGray from '../../assets/img/copy-settings-gray.png';
import deleteIconGray from '../../assets/img/delete-gray.png';
import adminIconGray from '../../assets/img/admin-icon-gray.png'

const OrganizationViews = ({ isUserView }) => {
    const { fetchOrganizationUsers, organization, organizationLoading,
        setOrganizationLoading, users, setUsers, organizationWindfarms, setOrganizationPopup, subscribeUserToNotification,
        unsubscribeUserFromNotification, activeNotificationWindfarmID, setActiveNotificationWindfarmID, selectedUserID,
        setSelectedUserID, showAddUserPopup, setShowAddUserPopup } =
        useContext(LassieContext);

    const [hoveredUserId, setHoveredUserId] = useState(null);
    const [hoveredWfId, setHoveredWfId] = useState(null);
    const [copySettings, setCopySettings] = useState({ is_active: false, source_id: null, target_user_ids: [] })
    const [showOptions, setShowOptions] = useState({ id: null, email: null, is_admin: null });
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

    const iconRefs = useRef({});

    const copyUserSettings = async (source_user_id, target_user_ids) => {
        setOrganizationPopup((prev) => ({ ...prev, show: false }));
        setOrganizationLoading(prev => ({
            ...prev,
            copySettings: {
                [source_user_id]: true,
                ...target_user_ids.reduce((acc, id) => ({ ...acc, [id]: true }), {})
            }
        }));

        try {
            const response = await organizationUserAPI.copyUserSettings(source_user_id, target_user_ids);
            if (response === "OK") {
                fetchOrganizationUsers(organization);
            }
        } catch (error) {
            console.error(`Error copying user settings:`, error);

            let errMessage = "An unexpected error occurred.";
            if (error.response) {
                errMessage = error.response.data?.message || error.response.data || "Server returned an error.";
            } else if (error.message) {
                errMessage = error.message;
            }

            setOrganizationPopup({
                show: true,
                status: 'warning',
                title: 'Something went wrong',
                buttonText: 'Close',
                buttonStatus: 'warning',
                text: errMessage
            });
        }

        setOrganizationLoading(prev => ({
            ...prev,
            copySettings: {
                [source_user_id]: false,
                ...target_user_ids.reduce((acc, id) => ({ ...acc, [id]: false }), {})
            }
        }));
        setCopySettings({ is_active: false, source_id: null, target_user_ids: [] });
    };

    const removeUserFromOrganization = async (target_user_id, organization_id) => {
        try {
            const response = await organizationUserAPI.removeUserFromOrganization(target_user_id, organization_id);
            if (response === 'OK') {
                setUsers(prevUsers => prevUsers.filter(user => user.id !== target_user_id));
                closePopupAndReset()
            }
        } catch (error) {
            console.error(`Error removing user from organization: ${error}`);
            setOrganizationPopup({
                show: true,
                status: 'warning',
                title: 'Something went wrong',
                buttonText: 'Close',
                buttonStatus: 'warning',
                text: error.response?.data
            });
        }
    };


    const handleUserAdminRole = async (target_user_id, is_admin) => {
        try {
            const response = await organizationUserAPI.updateUserAdminStatus(target_user_id, !is_admin);
            if (response === 'OK') {
                console.log(response)
                setUsers(prevUsers =>
                    prevUsers.map(user =>
                        user.id === target_user_id
                            ? { ...user, is_admin: !is_admin }
                            : user
                    )
                );
                closePopupAndReset()
            }
        } catch (error) {
            console.error(`Error removing user from organization: ${error}`);
            setOrganizationPopup({
                show: true,
                status: 'warning',
                title: 'Something went wrong',
                buttonText: 'Close',
                buttonStatus: 'warning',
                text: error.response?.data
            });
        }
    };

    const handleUserNotificationSubscription = async (isSubscribed, scenario_id, target_user_id) => {
        const frequency = 'daily';
        if (isSubscribed) {
            await unsubscribeUserFromNotification(scenario_id, frequency, target_user_id);
        } else {
            await subscribeUserToNotification(scenario_id, frequency, target_user_id)
        }
    };

    const getUserEmailById = (userId, users) => {
        const user = users.find(user => user.id === userId);
        return user ? user.email : 'Unknown';
    };

    const closePopupAndReset = () => {
        setOrganizationPopup((prev) => ({ ...prev, show: false }))
        setCopySettings({ is_active: false, source_id: null, target_user_ids: [] })
    }

    return (
        <>
            {isUserView ?
                <>
                    <div className='cards-area'>
                        <div className='organization-table-container organization-user-card'>
                            <table className='organization-table'>
                                <thead>
                                    <tr>
                                        <th className='action-header'>User <img src={addIcon} alt='Add user' className='header-icon' onClick={() => setShowAddUserPopup(!showAddUserPopup)} /></th>
                                        <th></th>
                                        {copySettings.is_active ?
                                            <th className='comment-action-container'>
                                                <button className='org-btn cancel-btn'
                                                    onClick={() => setCopySettings((prevSettings) => ({
                                                        ...prevSettings,
                                                        is_active: false,
                                                        source_id: null,
                                                        target_user_ids: []
                                                    }))}
                                                >X
                                                </button>
                                                <button
                                                    className='org-btn success-btn'
                                                    disabled={!copySettings.target_user_ids.length}
                                                    onClick={() => setOrganizationPopup({
                                                        show: true, status: 'warning',
                                                        buttonText: 'Cancel',
                                                        buttonStatus: 'wrong',
                                                        action: () => closePopupAndReset(),
                                                        title: 'Copy user settings',
                                                        buttonText2: 'Proceed',
                                                        buttonStatus2: 'success',
                                                        action2: () => copyUserSettings(copySettings.source_id, copySettings.target_user_ids),
                                                        text: `Are you sure you want to copy the settings from ${getUserEmailById(copySettings.source_id, users)} to ${copySettings.target_user_ids.map(id => getUserEmailById(id, users)).join(', ')}?`,
                                                    })}

                                                >✔</button>
                                            </th>
                                            :
                                            <th></th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {users && users.map(user => (
                                        <tr key={user.id}
                                            onClick={() => setSelectedUserID(user.id)}
                                            className={`organization-row
                                            ${selectedUserID === user.id ? 'selected-row' : ''} 
                                            ${organizationLoading.copySettings?.[user.id] ? 'updating-row' : ''}`}
                                            onMouseEnter={() => setHoveredUserId(user.id)}
                                            onMouseLeave={() => setHoveredUserId(null)}
                                        >
                                            <td className='username-column'>{user.email}{user.is_admin ?
                                                <img src={adminIcon} alt='Admin user' className='action-icon' /> : null}
                                            </td>
                                            <td>
                                                {copySettings.is_active && user.id !== copySettings.source_id && (
                                                    <input
                                                        type='checkbox'
                                                        checked={copySettings.target_user_ids.includes(user.id)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setCopySettings((prevSettings) => ({
                                                                    ...prevSettings,
                                                                    target_user_ids: [...prevSettings.target_user_ids, user.id],
                                                                }));
                                                            } else {
                                                                setCopySettings((prevSettings) => ({
                                                                    ...prevSettings,
                                                                    target_user_ids: prevSettings.target_user_ids.filter((id) => id !== user.id),
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </td>

                                            <td
                                                className='option-cell'
                                                onClick={() => {
                                                    const icon = iconRefs.current[user.id];
                                                    if (icon) {
                                                        const rect = icon.getBoundingClientRect();
                                                        setMenuPosition({
                                                            top: rect.bottom + window.scrollY,
                                                            left: rect.left + window.scrollX + 15,
                                                        });
                                                        setShowOptions({ id: user.id, email: user.email, is_admin: user.is_admin });
                                                    }
                                                }}
                                            >
                                                <img
                                                    src={optionIcon}
                                                    alt='User options'
                                                    className='action-icon option-btn'
                                                    ref={(el) => (iconRefs.current[user.id] = el)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                    }
                                </tbody>
                            </table>
                        </div>

                        {showOptions?.id && createPortal(
                            <div
                                className="options-container"
                                style={{
                                    position: 'absolute',
                                    top: menuPosition.top,
                                    left: menuPosition.left,
                                    zIndex: 9999,
                                }}
                            >
                                <OptionsMenu
                                    options={[
                                        {
                                            label: 'Copy user settings',
                                            onClick: () => {
                                                setCopySettings((prevSettings) => ({
                                                    ...prevSettings,
                                                    is_active: true,
                                                    source_id: showOptions.id
                                                }));
                                            },
                                            img: copySettingsIconGray,
                                        },
                                        {
                                            label: `${showOptions.is_admin ? "Remove admin rights" : "Grant admin access"}`,
                                            onClick: () => setOrganizationPopup({
                                                show: true, status: 'warning',
                                                buttonText: 'Cancel',
                                                buttonStatus: 'wrong',
                                                action: () => closePopupAndReset(),
                                                title: 'Delete user',
                                                buttonText2: 'Accept',
                                                buttonStatus2: 'success',
                                                action2: () => handleUserAdminRole(showOptions.id, showOptions.is_admin),
                                                text: `${showOptions.is_admin ? `Are you sure you want to remove admin rights from ${showOptions.email}?` : `Are you sure you want to make ${showOptions.email} an admin?`}`
                                            }),
                                            img: adminIconGray,
                                        },
                                        {
                                            label: 'Delete',
                                            onClick: () => setOrganizationPopup({
                                                show: true, status: 'warning',
                                                buttonText: 'Cancel',
                                                buttonStatus: 'success',
                                                action: () => closePopupAndReset(),
                                                title: 'Delete user',
                                                buttonText2: 'Delete',
                                                buttonStatus2: 'wrong',
                                                action2: () => removeUserFromOrganization(showOptions.id, organization.id),
                                                text: `Are you sure you want to remove ${showOptions.email} from ${organization.name}?`,
                                            }),
                                            img: deleteIconGray,
                                        },
                                    ]}
                                    onClose={() => setShowOptions(null)}
                                />
                            </div>,
                            document.body
                        )}

                        <div className='organization-table-container organization-card'>
                            <table className='organization-table'>
                                <thead>
                                    <tr>
                                        <th>Assigned windfarms</th>
                                        <th>Role</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedUserID ?
                                        users.find(user => user.id === selectedUserID)?.windfarms
                                            .map(wf => (
                                                <tr key={wf.id} onClick={() => setActiveNotificationWindfarmID(wf.id)}
                                                    className={`organization-row
                                                        ${organizationLoading.updatedRole && organizationLoading.updatedRole[wf.id] ? 'updating-row' : ''} 
                                                        ${activeNotificationWindfarmID === wf.id ? 'selected-row' : ''}
                                                    `}
                                                    onMouseEnter={() => setHoveredWfId(wf.id)}
                                                    onMouseLeave={() => setHoveredWfId(null)}
                                                >
                                                    <td>{wf.name}</td>
                                                    <td className='action-cell'>
                                                        {(hoveredWfId === wf.id || activeNotificationWindfarmID === wf.id)
                                                            ? (
                                                                <button className="org-btn action-btn edit-role-btn"
                                                                    onClick={() => {
                                                                        const newRole = wf.role || 'no access';
                                                                        setOrganizationPopup({
                                                                            show: true,
                                                                            status: 'warning',
                                                                            title: 'Update role',
                                                                            buttonText: 'Cancel',
                                                                            buttonStatus: 'wrong',
                                                                            action: () => closePopupAndReset(),
                                                                            text: `Are you sure you want to change ${users.find(user => user.id === selectedUserID)?.email}'s role on ${wf.name}?`,
                                                                            buttonText2: 'Update',
                                                                            buttonStatus2: 'success',
                                                                            action2: 'role-update',
                                                                            updated_role: newRole
                                                                        });
                                                                    }}
                                                                    disabled={organizationLoading.updatedRole && Object.values(organizationLoading.updatedRole).includes(true)}
                                                                >
                                                                    {wf.role ? wf.role.charAt(0).toUpperCase() + wf.role.slice(1) : "No access"}
                                                                    <span className="icon-container">
                                                                        <img src={editIcon} alt="Edit user role" className="action-icon default-icon" />
                                                                        <img src={editWhiteIcon} alt="Edit user role" className="action-icon hover-icon" />
                                                                    </span>
                                                                </button>
                                                            ) : wf.role ? wf.role.charAt(0).toUpperCase() + wf.role.slice(1) : "No access"
                                                        }
                                                    </td>
                                                </tr>
                                            )) :
                                        <tr>
                                            <td colSpan="2">
                                                <p className='legend'>Click on a User to view the assigned windfarms</p>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className='organization-table-container organization-card'>
                            <table className='organization-table'>
                                <thead>
                                    <tr>
                                        <th>Notifications</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedUserID && activeNotificationWindfarmID ? (
                                        users.find(user => user.id === selectedUserID)?.windfarms
                                            .filter(wf => wf.id === activeNotificationWindfarmID)
                                            .map(wf => (
                                                <React.Fragment key={wf.id}>
                                                    {
                                                        wf.role === null ? (
                                                            <tr>
                                                                <td colSpan="2">
                                                                    <p className="legend">This user doesn't have access to this windfarm</p>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            wf.scenarios.map(notification => (
                                                                <tr key={notification.id}
                                                                    className={`organization-row ${organizationLoading.notification[notification.id] ? 'updating-row' : ''
                                                                        }`}>
                                                                    <td className={`${notification.title ? 'notification-title' : ''
                                                                        }`}>{notification.title || 'No notifications available for this windfarm.'}</td>
                                                                    <td>
                                                                        {
                                                                            notification.title ? (
                                                                                <WplSwitch
                                                                                    value={notification.subscribed}
                                                                                    onChanged={() => handleUserNotificationSubscription(
                                                                                        notification.subscribed,
                                                                                        notification.id,
                                                                                        selectedUserID,
                                                                                    )}
                                                                                />
                                                                            ) : (
                                                                                ''
                                                                            )
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )
                                                    }
                                                </React.Fragment>
                                            ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2">
                                                <p className="legend">Click on a windfarm to view the subscribed notifications</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>

                    </div>
                    {copySettings.is_active && <p className='instruction-text'>Select users to copy settings to...</p>}
                </>
                :
                <div className='cards-area'>
                    <div className='organization-table-container organization-card'>
                        <table className='organization-table'>
                            <thead>
                                <tr>
                                    <th className='action-header'>Windfarms</th>
                                </tr>
                            </thead>
                            <tbody>
                                {organizationWindfarms && organizationWindfarms.map(wf => (
                                    <tr key={wf.id} onClick={() => setActiveNotificationWindfarmID(wf.id)} className={activeNotificationWindfarmID === wf.id ? 'selected-row' : ''}
                                        onMouseEnter={() => setHoveredWfId(wf.id)}
                                        onMouseLeave={() => setHoveredWfId(null)}
                                    >
                                        <td>{wf.name}</td>
                                    </tr>

                                ))
                                }
                            </tbody>
                        </table>
                    </div>

                    <div className='organization-table-container organization-card'>
                        <table className='organization-table'>
                            <thead>
                                <tr>
                                    <th>Assigned Users</th>
                                    <th>role</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activeNotificationWindfarmID ?
                                    organizationWindfarms.find(wf => wf.id === activeNotificationWindfarmID)?.users
                                        .map(user => (
                                            <tr key={user.id} onClick={() => setSelectedUserID(user.id)}
                                                className={`
                                                        ${organizationLoading.updatedRole && organizationLoading.updatedRole[user.id] ? 'updating-row' : ''} 
                                                        ${selectedUserID === user.id ? 'selected-row' : ''}
                                                    `}
                                                onMouseEnter={() => setHoveredUserId(user.id)}
                                                onMouseLeave={() => setHoveredUserId(null)}
                                            >
                                                <td>{user.email}</td>
                                                <td className='action-cell'>
                                                    {(hoveredUserId === user.id || selectedUserID === user.id)
                                                        ? (
                                                            <button className="org-btn action-btn edit-role-btn"
                                                                onClick={() => {
                                                                    const newRole = user.role || 'no access';
                                                                    setOrganizationPopup({
                                                                        show: true,
                                                                        status: 'warning',
                                                                        title: 'Update role',
                                                                        buttonText: 'Update',
                                                                        buttonStatus: 'success',
                                                                        action: 'role-update',
                                                                        text: `Are you sure you want to change ${user.email}'s role on ${organizationWindfarms.find(wf => wf.id === activeNotificationWindfarmID)?.name}?`,
                                                                        buttonText2: 'Cancel',
                                                                        buttonStatus2: 'wrong',
                                                                        action2: () => closePopupAndReset(),
                                                                        updated_role: newRole
                                                                    });
                                                                }}
                                                                disabled={organizationLoading.updatedRole && Object.values(organizationLoading.updatedRole).includes(true)}
                                                            >
                                                                {user.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : "No access"}
                                                                <span className="icon-container">
                                                                    <img src={editIcon} alt="Edit user role" className="action-icon default-icon" />
                                                                    <img src={editWhiteIcon} alt="Edit user role" className="action-icon hover-icon" />
                                                                </span>
                                                            </button>
                                                        ) : user.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : "No access"
                                                    }
                                                </td>
                                            </tr>
                                        )) :
                                    <tr>
                                        <td colSpan="2">
                                            <p className='legend'>Click on a Windfarm to view the assigned users</p>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            }
        </>
    )
}

export default OrganizationViews